export function isIE11() {
  // detect IE11 according to https://docs.microsoft.com/en-us/previous-versions/dn433247(v=vs.85)
  // https://stackoverflow.com/a/21825207/54378
  return !!window.MSInputMethodContext && !!document.documentMode;
}
